<div role= "list-item" class="eui-list-item__container" [class.eui-list-item--has-submenu]="euiListComponent.length > 0">
    <div class="eui-list-item__content">
        <div *ngIf="euiIconComponent.length > 0" class="eui-list-item__content-icon">
            <ng-content select="[eui-icon], [euiIcon]"></ng-content>
        </div>
        <div *ngIf="euiLabelComponent.length > 0" class="eui-list-item__content-text">
            <ng-content select="[eui-label], [euiLabel]"></ng-content>
        </div>
        <div *ngIf="euiListComponent.length > 0 && isCollapsible" class="eui-list-item__content-toggle" [class.eui-list-item__content-toggle--expanded]="!isCollapsed" (click)="toggleCollapse($event)">
            <span euiIcon euiSecondary euiSizeXL iconClass="eui-icon-angle-down" aria-label= "{{ isCollapsed? 'Expand': 'Collapse' }}"></span>
        </div>
    </div>
    <div class="eui-list-item__sub-list" *ngIf="(euiListComponent.length > 0 && !isCollapsed) || (euiListComponent.length > 0 && !isCollapsible)">
        <ng-content select="[eui-list], [euiList]"></ng-content>
    </div>
    <ng-content></ng-content>
</div>
